import React, { useState, useEffect, useRef, useContext } from 'react'
import { FormattedMessage, FormattedDate, FormattedNumber, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import messages from './messages'

const InvoiceRow = ({ invoice: { invoiceId, orderId, order, netAmount, draft, currency, dueDate, remainder, pfdHref, type } }) => {
  const { formatMessage } = useIntl()

  return (
    <tr
      key={invoiceId}
      className={{
        '': 'hover:bg-gray-100',
        'Draft': 'bg-yellow-50 hover:bg-yellow-100',
        'Credit Note': 'bg-red-50 hover:bg-red-100',
      }[type] + ' cursor-pointer border-b border-gray-100'}
      tabIndex={0}
    >
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <div className="flex items-center w-full truncate justify-center lg:justify-start">
          <span className={{
            'Credit Note': 'w-2 h-2 rounded-full bg-red-400',
            'Draft': 'w-2 h-2 rounded-full bg-yellow-400',
            '': parseInt(remainder, 10) > 0 ?
              'w-2 h-2 rounded-full bg-primary' :
              'w-2 h-2 rounded-full bg-positive'
          }[type]} />

          <span className="ml-2 capitalize hidden lg:flex">
            { parseInt(remainder, 10) > 0 ? (
              <FormattedMessage {...messages.unpaid } />
            ) : {
              '': <FormattedMessage {...messages.paid } />,
              'Draft': <FormattedMessage {...messages.draft } />,
              'Credit Note': <FormattedMessage {...messages.creditNote } />,
            }[type] }
          </span>
        </div>
      </td>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <span>#{ invoiceId }</span>
      </td>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate space-x-1 text-primary hover:text-primary-darker">
        <Link to={`/orders?query=${orderId}`}>
          { orderId }
        </Link>

        <Icon icon="link" className="text-xs" />
      </td>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        { order?.name || 'N/A' }
      </td>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <FormattedDate value={new Date(dueDate)} />
      </td>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <FormattedNumber value={netAmount} style="currency" currency={currency} />
      </td>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <FormattedNumber value={remainder} style="currency" currency={currency} />
      </td>

      <td className="w-20 px-1 xl:px-4 py-2 xl:py-3">
        <a
          target="_blank"
          href={`/invoice/pdf?invoiceId=${invoiceId}&orderId=${orderId}&draft=${+draft}`}
          className="z-0 w-8 h-8 flex justify-center items-center rounded-full hover:bg-gray-100 text-gray-400 hover:text-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-darker z-0"
          id="user-menu"
          aria-haspopup="true"
          title={formatMessage(messages.download)}
        >
          <span className="sr-only"><FormattedMessage{...messages.download}/></span>
          <Icon icon="download" />
        </a>
      </td>
    </tr>
  )
}

export default InvoiceRow
